import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    declare imageableTypeValue: string
    declare imageableIdValue: number

    static values = {
        imageable_id: Number,
        imageable_type: String
    }

    open(e: Event) {
        e.preventDefault()
        this.dispatch("open", {
            prefix: "modal",
            detail: {
                id: this.imageableIdValue,
                type: this.imageableTypeValue
            }
        })
    }
}
